import React ,{useEffect,useState} from 'react';
import { useLocation,useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";

function Addtable() {
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tableId = queryParams.get("id");
    const navigate = useNavigate();
  const token = localStorage.getItem("token");

const [formdata, setForm] = useState({ no:"",floor: "",person:"", qrcode: "" ,status:""});
      const [errors, setErrors] = useState({});
      const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState("");
    
      useEffect(() => {
          if (tableId) {
            const fetchtable = async () => {
              try {
                const { data } = await apiClient.get(ADMIN.GET_TABLE);
                if (data.success) {
                  const table = data.items.find(p => p._id === tableId);
                  if (table) {
                    setForm({
                      no: table.Table_No,
                      floor: table.Floor,
                      person: table.Person,
                      qrcode: table.QR_Code,
                      status: table.Status
                    });
                  }
                }
              } catch (err) {
                console.error("Error fetching table:", err);
                toast.error(err.response?.data?.message || err.message || "Failed to fetch table data");
              }
            };
            fetchtable();
          }
        }, [tableId]);

      const validate = () => {
        const e = {};
        if (!formdata.no )
          e.no = "Number Requiered";
        if (!formdata.floor)
          e.floor = "floor required";
        if (!formdata.person) e.person = "person required";
        if (!formdata.qrcode) e.qrcode = "QR code required";
        if (!formdata.status) e.status = "Status required";
        setErrors(e);
        return Object.keys(e).length === 0;
      };
    
      const formChangeData = (ev) => {
        const { name, value } = ev.target;
            
            setForm((f) => ({ ...f, [name]: value }));
          
          setMessage("");
      };
    
      const handleSubmit = async (ev) => {
  ev.preventDefault();
  if (!validate()) return;
  setLoading(true);
  setMessage("");
  

  try {
    const url = tableId ? ADMIN.UPDATE_TABLE(tableId) : ADMIN.ADD_TABLE;
    const method = tableId ? "put" : "post";

    const { data } = await apiClient[method](url, formdata);
    if (!data.success) throw new Error(data?.message || "Operation failed");

    toast.success(data.message || (tableId ? "Table updated successfully" : "Table added successfully"));
    if(!tableId)
    {
    setForm({ no:"",floor: "",person:"", qrcode: "" ,status:""});
    }
    setTimeout(() => {
      navigate("/table");
    }, 1000);
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Operation failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <div>
        
      <div className="col-12 grid-margin container-scroller" >
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title"></h4>
                    <form method="post" onSubmit={handleSubmit} className="form-sample">
                      <p className="card-description"> Add Table </p>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Table No</label>
                            <div className="col-sm-9">
                              <input type="text" name="no" value={formdata.no} onChange={formChangeData} className="form-control" />
                              {errors.no && <small className="text-danger">{errors.no}</small>}
                            </div>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Floor</label>
                            <div className="col-sm-9">
                              <input type="text" name="floor" value={formdata.floor} onChange={formChangeData} className="form-control" />
                              {errors.floor && <small className="text-danger">{errors.floor}</small>}
                            </div>
                          </div>
                        </div>
                    </div>

                        <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Person</label>
                            <div className="col-sm-9">
                              <input type="text" name="person" value={formdata.person} onChange={formChangeData} className="form-control" />
                              {errors.person && <small className="text-danger">{errors.person}</small>}
                            </div>
                          </div>
                        </div>
                      
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">QR code</label>
                            <div className="col-sm-9">
                              <input className="form-control" name="qrcode" value={formdata.qrcode} onChange={formChangeData} />
                              {errors.qrcode && <small className="text-danger">{errors.qrcode}</small>}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Status</label>
                            <div className="col-sm-9">
                              <select className="form-control" name="status" value={formdata.status} onChange={formChangeData}>
                                <option value="">-- Select Status --</option>
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                              {errors.status && <small className="text-danger">{errors.status}</small>}
                            </div>
                          </div>
                        </div>
                       {/* <div className="col-md-6">
                          <label>Image</label>
                          <input type="file" name="image" onChange={formChangeData} className="form-control" />
                          {errors.image && <small className="text-danger">{errors.image}</small>}
                        </div> */}
                        <div className="row mt-3">
                          <div className="col-md-12 text-center">
                            <button 
                              type="submit" 
                              className="btn btn-primary" 
                              >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default Addtable